export default {"src":"/_next/static/media/ComprehensivePreandPostOperativeCare.5a5f85cc.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};